import React, {useEffect, useState} from 'react';
import styles from './General.module.scss';
import Info from "./Info/Info";
import {GeneralMethods} from "@/views/Admin/Events/Event/General/General.methods";
import Header from "./Header/Header";
import {GeneralSchema} from "@/views/Admin/Events/Event/General/General.schema";
import {useLocation, useParams} from "react-router-dom";
import {Preloader} from "uikit";
import {useDispatch, useSelector} from "react-redux";

const General = () => {
    const params: { id: any } = useParams()
    const location = useLocation()
    const eventType = location.pathname.includes('courses') ? 'courses' : 'events';
    const admin = useSelector(state => state.admin);
    const dispatch = useDispatch();
    const [data, setData] = useState({...GeneralSchema, eventType: eventType})
    const {
        getEventResource,
        getConstants,
        getUserPermissions,
    } = GeneralMethods;

    useEffect(() => {
        handleGetEventParams()
        handleGetConstants()
        handleGetUserPermissions()
    }, []);

    const handleGetUserPermissions = async () => {
        let response
        try {
            response = await getUserPermissions(eventType, params.id);
            if ([200, 201].includes(response.status)) {
                setData(prev => ({...prev, permissions: response.data.data}))
            }
        } catch (err) {
            console.log(err)
        }
    }

    const handleGetConstants = async () => {
        let response;
        try {
            response = await getConstants()
            setData((prev) => ({...prev, constants: response.data.data}))
        } catch (err) {
            console.log(err)
        }
    }

    const handleGetEventParams = async () => {
        setData(prev => ({...prev, isLoading: true}))
        try {
            const response = await getEventResource(eventType, params?.id)
            if (!Object.keys(admin.event).length) {
                // затычка для страницы настройки курсов
                dispatch({type: "SET_ADMIN", payload: {...admin, event: {...admin.event, ...response}}})
            }

            setData((prev) => {
                let obj = JSON.parse(JSON.stringify(prev));
                Object.keys(prev.fields).forEach(key => {
                    obj.fields[key].value = response[key] !== undefined ? response[key] : obj.fields[key].value;
                });
                Object.keys(response).forEach(key => {
                    if (!(key in prev.fields)) {
                        obj[key] = response[key];
                    }
                });
                return obj;
            });
        } catch (err) {
            // @ts-ignore
            showTopMessage('error', 'small', 'При загрузке данных произошла ошибка');
        } finally {
            setData(prev => ({...prev, isLoading: false}))
        }
    }

    return (
        <>
            {data.isLoading ?
                <div className={styles.preloader}>
                    <Preloader/>
                </div> : null
            }
            {!data.isLoading ?
                <div className={styles.container}>
                    {data.permissions &&
                        <>
                            <Header
                                data={data}
                                onChange={setData}
                                onUpdate={handleGetEventParams}
                            />
                            {data.fields.title.value ?
                                <Info
                                    data={data}
                                    onChange={setData}
                                    onUpdate={handleGetEventParams}
                                /> : null
                            }
                        </>
                    }
                </div> : null
            }
        </>
    );
};

export default General;
